// frontend/src/pages/HomePage.jsx
import React from "react";
import Header from "../components/Header";
import HeroSlider from "../components/HeroSlider";
import AboutSection from "../components/AboutSection";
import CoursesSection from "../components/CoursesSection";
import InstructorSection from "../components/InstructorSection";
import AreasSection from "../components/AreasSection";
import ContactSection from "../components/ContactSection";
import CarAnimation from "../components/CarAnimation";
import FAQSection from "../components/FAQSection";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

const HomePage = () => {
  return (
    <>
      <WhatsAppButton />
      <Header />

      <div id="hero">
        <HeroSlider />
      </div>

      <div id="about">
        <AboutSection />
      </div>

      <div id="courses">
        <CoursesSection />
      </div>

      <div id="Instructor">
        <InstructorSection />
      </div>

      <div id="areas">
        <AreasSection />
      </div>

      <div id="contact">
        <ContactSection />
      </div>

      <CarAnimation />

      <div id="faq">
        <FAQSection />
      </div>

     

      <Footer />
    </>
  );
};

export default HomePage;